import { useResponsive } from '../contexts/ResponsiveContext';

export function useIsMobile() {
  const { isMobile, isTablet, isTouch, isLandscapeMobile } = useResponsive();
  // isTouch covers phones in landscape where width > 768px but pointer is still coarse
  return { isMobile: isMobile || isTouch, isTablet, isTouch, isLandscapeMobile };
}
